import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=c5b5a4f8&scoped=true&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5a4f8",
  null
  
)

export default component.exports